import React from 'react';
import { formatOrderDateToLocalTime, priceFormat } from '../../../../util';
import { TrackingLinkOrInfo } from '../Common/TrackingLinkOrInfo/TrackingLinkOrInfo';
import * as toolSelectors from '../../../../selectors/tools';
import { useSelector } from 'react-redux';
import {
  ResultsColumn,
  ResultsColumnHeader,
  Row,
  HeaderRow,
  SubTitleText,
  Spreadsheet,
  TitleRow,
  ColumnTitle,
  TitleText,
  NotLastItem,
  LastItem,
  Column,
} from '../DTInfoWidget.styles';

const DTSalesforceOrderDetailsWidget = () => {
  const selectedLineItems = useSelector(toolSelectors.getSelectedLineItems) || [];
  const { Id, CreatedDate, TotalAmount } = useSelector(toolSelectors.getSelectedOrder);

  return (
    <>
      <TitleRow className="fs-block">
        <ColumnTitle>
          <TitleText>
            ORDER ID: <br />
            {Id}
          </TitleText>
        </ColumnTitle>
        <Column>
          <NotLastItem>
            DATE OF ORDER: <br />
            {formatOrderDateToLocalTime(CreatedDate, 'salesforce')}
          </NotLastItem>
          <LastItem>
            TOTAL PRICE: <br />
            {priceFormat(TotalAmount)}
          </LastItem>
        </Column>
      </TitleRow>
      <Spreadsheet className="fs-block">
        <SubTitleText>Order Details</SubTitleText>
        <HeaderRow>
          <ResultsColumnHeader>ITEM</ResultsColumnHeader>
          <ResultsColumnHeader>QUANTITY</ResultsColumnHeader>
          <ResultsColumnHeader>TOTAL PRICE</ResultsColumnHeader>
          <ResultsColumnHeader>TRACKING</ResultsColumnHeader>
        </HeaderRow>
        {selectedLineItems.map((item, key) => (
          <Row key={key}>
            <ResultsColumn>{item.name}</ResultsColumn>
            <ResultsColumn>{item.Quantity}</ResultsColumn>
            <ResultsColumn>{priceFormat(item.TotalPrice)}</ResultsColumn>
            <ResultsColumn>
              <TrackingLinkOrInfo item={item} />
            </ResultsColumn>
          </Row>
        ))}
      </Spreadsheet>
    </>
  );
};
export default DTSalesforceOrderDetailsWidget;
